<div class="currency">
  ({{ currency?.code }}<ng-container *ngIf="currency?.name">{{ ' ' + currency.name }}</ng-container
  >)
</div>
